<template>
  <v-dialog v-model="dialog" max-width="400" class="telegram-dialog">
    <v-card class="share-dialog">
      <v-card-title class="d-flex justify-center pt-6">
        <span class="text-h6 dialog-title">Junte-se a nós</span>
        <v-btn icon class="close-btn" @click="close">
          <img :src="Closed" style="width: 18px; height: 18px" alt="" />
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-6">

        <div class="reward-list">
          <div class="reward-item d-flex align-center mb-4">
            <!-- <div class="number pink--text">1</div> -->
            <div class="text">Junte-se aos nossos canais oficiais de Telegram e WhatsApp para ter acesso
              a:</div>
          </div>
          <div class="reward-item d-flex align-center mb-4">
            <div class="number pink--text">1</div>
            <div class="text">
              Códigos de resgate enviados diretamente no canal, com acesso rápido aos códigos de bônus em dinheiro.
            </div>
          </div>
          <div class="reward-item d-flex align-center mb-4">
            <div class="number pink--text">2</div>
            <div class="text">
              Fique por dentro de novos lançamentos de plataformas e ofertas especiais em primeira mão.
            </div>
          </div>
          <div class="reward-item d-flex align-center mb-4">
            <div class="number pink--text">3</div>
            <div class="text">
              Acompanhe os resultados das atividades de jackpot e rankings no canal.
            </div>
          </div>
          <div class="reward-item d-flex align-center mb-4">
            <div class="number pink--text">4</div>
            <div class="text">
              Votação exclusiva para decidir novos benefícios e promoções.
            </div>
          </div>
        </div>
        <v-btn block class="mt-6 white--text submit-btn" height="48" @click="joinTelegram">
          {{ btnStr }}
        </v-btn>
        <v-btn v-if="userInfo.value?.user_type !== 2 && getToken()" block class="mt-6 white--text submit-btn"
          height="48" @click="joinWhatsApp">
          Canal Oficial do WhatsApp
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from "vue";
import { fetchServiceLink } from "@/api/customer-service.ts";
import Closed from "@/assets/images/h5/close.png";
import { getToken, getUserInfo } from "@/utils/auth";
import { useStore } from "vuex";
import router from "@/router";
import { loginEvent, SHOW_REGISTER_EVENT } from "@/api/request";

const dialog = ref(false);
const store = useStore();
const telegramLink = ref(""); // 替换为实际的 Telegram 频道链接
const direct_link = ref(""); // 替换为实际的 WhatsApp 频道链接
const userInfo = computed(() => store.state.auth.user || {});

const show = () => {
  if (getToken()) {
    getCustomerServiceGroups();

  }

  dialog.value = true;
};

const close = () => {
  dialog.value = false;
};

const btnStr = computed(() => {
  if (!getToken()) {
    return "Cadastre-se Agora";
  } else if (userInfo.value?.user_type === 2) {
    return "Vincular Numero de Telefone";
  } else {
    return "Canal Oficial do Telegram";
  }
});

const getCustomerServiceGroups = async () => {
  const res: any = await fetchServiceLink();
  const data = res?.data || res;
  const channels = data?.channels || [];
  const normalize = (v: string) => (v || "").replace(/`/g, "").trim();
  const findChannel = (platform: string) =>
    channels.find((c: any) => (c?.platform || "").toLowerCase() === platform.toLowerCase());
  telegramLink.value = normalize(findChannel("TG")?.link || "");
  direct_link.value = normalize(findChannel("Whatsapp")?.link || "");
};
const joinTelegram = () => {
  if (!getToken()) {
    loginEvent.dispatchEvent(new Event(SHOW_REGISTER_EVENT));
  } else if (userInfo.value?.user_type === 2) {
    // 如果是游客（未绑定手机号），触发手机号绑定提示事件
    // 跳转到手机号绑定页面
    router.push("/phone-binding");
  } else if (telegramLink.value) {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      // iOS需要用户交互触发window.open
      setTimeout(() => {
        window.location.href = telegramLink.value;
      }, 100);
    } else {
      window.open(telegramLink.value, "_self");
    }
  }
  close();
};
const joinWhatsApp = () => {
  if (!direct_link.value) {
    return;
  }
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  if (isIOS) {
    // iOS需要用户交互触发window.open
    setTimeout(() => {
      window.location.href = direct_link.value;
    }, 100);
  } else {
    window.open(direct_link.value, "_self");
  }
  close();
};
onMounted(() => {
  window.addEventListener("show-join-us", show as EventListener);
});

onUnmounted(() => {
  window.removeEventListener("show-join-us", show as EventListener);
});
defineExpose({
  show,
  close,
});
</script>

<style lang="scss" scoped>
.telegram-dialog {
  :deep(.v-dialog) {
    @media (max-width: 768px) {
      width: 90% !important;
      margin: 0 auto;
    }
  }
}

.share-dialog {
  border-radius: 20px !important;
  background: #1a1c2e;

  :deep(.v-card-text) {
    @media (max-width: 768px) {
      padding-top: 0 !important;
    }
  }

  :deep(.v-card-title) {
    color: white;
    position: relative;
    // white-space: wrap;

    .close-btn {
      position: absolute;
      right: 16px;
      top: 16px;
      background: none;
    }

    .dialog-title {
      display: flex;
      font-size: 1.25rem;



      @media (max-width: 768px) {
        font-size: 1.1rem;
      }
    }
  }
}

.reward-list {
  .reward-item {
    @media (max-width: 768px) {
      margin-bottom: 5px !important;
    }

    .number {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: rgba(255, 32, 110, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12px;
      font-weight: bold;
      flex-shrink: 0;
    }

    .text {
      color: white;
      flex: 1;
      font-size: 14px;
      line-height: 1.4;

      @media (max-width: 768px) {
        font-size: 13px;
      }
    }
  }
}

.submit-btn {
  background: linear-gradient(0deg, #c9b737, #2abb27);
  color: white;
  border-radius: 20px;
  height: 40px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: none;

  @media (max-width: 768px) {
    height: 35px !important;
    font-size: 13px;
    padding: 0 12px;
  }
}
</style>
